export default {"src":"/_next/static/media/subscription-logo.955bd62c.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};